module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.collection.length > 0) { 
    ; __append(" <ul class=\"list-unstyled\"> ")
    ;  _.each(locals.collection.models, function(model) { 
    ; __append(" <li id=\"")
    ; __append(escapeFn( locals.computeId(model.id || model.cid) ))
    ; __append("\" class=\"list__body__item__subitem row\"></li> ")
    ;  }); 
    ; __append(" </ul> ")
    ;  }
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/sub_items_list/template.ejs
// module id = 1237
// module chunks = 1